import * as React from "react"
import ProductItem from "./ProductItem"
import "./styles.scss"

export default function ProductPassportDataSection({ data, isProductPassportView, isSectionOpen, setIsSectionOpen, setSelectedTab }) {
    return (
        <div className="product-data-section">
            {data.map((item, index) => (
                <ProductItem
                    key={`product-item-${index}`}
                    itemData={item}
                    index={index}
                    isProductPassportView={isProductPassportView}
                    isSectionOpen={isSectionOpen}
                    setIsSectionOpen={setIsSectionOpen}
                />
            ))}
        </div>
    )
}
